'use client';

import { usePathname } from 'next/navigation';

export const useSearchPage = (): boolean => {
    const pathname = usePathname();

    return Boolean(pathname && pathname.includes('/search'));
};
